import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { resolveInitialLanguage } from './utils/language.utils';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    // Start from the operator's saved choice (or a supported browser preference)
    // instead of always falling back to Russian.
    lng: resolveInitialLanguage(),
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'kk', 'en'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
